import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["activeClassName", "activeStyle", "activeProps", "children", "className", "exact", "style", "to"];
import PropTypes from 'prop-types';
import cx from 'classnames';
import useIsActive from './internal/useIsActive';
import UIRouterLink from './UIRouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * A [`Link`](https://private.hubteamqa.com/foundations-components-storybook/?path=/docs/transitional-link--page)
 * type component with router support.
 * Supports `activeProps` for overriding the props when the button is active.
 */
export default function UIRouterNavLink(props) {
  const {
      activeClassName,
      activeStyle,
      activeProps,
      children,
      className,
      exact,
      style,
      to
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const active = useIsActive(to, exact);

  // TODO remove this after deprecating activeClassName from other projects
  const classes = cx(className, activeClassName && {
    [activeClassName]: active
  });

  // TODO remove this line after deprecating style & activeStyle from other projects
  const legacyStyles = {
    style: Object.assign({}, style, active ? activeStyle : null)
  };
  return /*#__PURE__*/_jsx(UIRouterLink, Object.assign({}, rest, {
    "aria-current": active ? 'page' : undefined,
    className: classes,
    to: to
  }, activeProps ? {} : legacyStyles, active ? activeProps : {}, {
    children: children
  }));
}

// TODO remove after deprecating UIComponents part
UIRouterNavLink.propTypes = Object.assign({}, UIRouterLink.propTypes, {
  activeProps: PropTypes.object,
  activeClassName: PropTypes.string,
  activeStyle: PropTypes.object,
  className: PropTypes.string,
  exact: PropTypes.bool.isRequired,
  style: PropTypes.object.isRequired
});

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIRouterNavLink.defaultProps = Object.assign({}, UIRouterLink.defaultProps, {
  exact: false,
  style: {}
});